import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from '../../Components/Header';
import { useDispatch } from 'react-redux';
import { familyList, deleteFamily } from '../../Redux/Slices/userAnalyticsSlice';
import { FiTrash2 } from 'react-icons/fi';
import DeleteModal from '../../Components/DeleteModal';
import toast from 'react-hot-toast';
// import useNavigateWithParams from './useNavigateWithParams';

const EditFamilyList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let { id } = useParams();
    // const navigateWithParams = useNavigateWithParams();   
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);

    const getFamilyListFun = async () => {
        try {
            setLoading(true);
            const payload = {
                userId: id,
            };
            const response = await dispatch(familyList(payload)).unwrap();
            setTableData(response.Data);
            // setPaginationData(response.Data.totalDocs);
        } catch (error) {
            console.log("error :>> ", error);
        } finally {
            setLoading(false);
        }
    };

    const addFamilyMember = (memberId) => {
        if (memberId && id) {
            navigate(`/edit-family-list/family-details/${id}/${memberId}`);
        } else if (id) {
            navigate(`/edit-family-list/family-details/${id}`);
        } else {
            navigate('/edit-family-list/family-details');
        }
    };

    const handleDeleteClick = (memberId) => {
        setIdToDelete(memberId);
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await dispatch(deleteFamily({ familyMemberId: idToDelete })).unwrap();
            if (response?.IsSuccess) {
                toast.success(response?.Message || "Family member deleted successfully");
                getFamilyListFun();
            }
        } catch (error) {
            toast.error("Failed to delete family member");
        } finally {
            setIsDeleteModalOpen(false);
            setIdToDelete(null);
        }
    };

    // const addFamilyMember = (memberId, otherId = id) => {
    //     const pathname = memberId
    //         ? `/edit-family-list/family-details/${memberId}`
    //         : '/edit-family-list/family-details';
    //     const params = { otherId };
    //     // navigateWithParams(pathname, params);
    // };


    useEffect(() => {
        getFamilyListFun();
    }, []);

    return (
        <>
            <div className="h-screen bg-white p-4">
                <div className="flex items-center mb-6">
                    <Link to="/users-analytics" className="text-teax_1 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                        </svg>
                        Back
                    </Link>
                    <div className='flex ml-auto space-x-2'>
                        <button className="btn flex justify-center items-center space-x-1" onClick={() => addFamilyMember()}>
                            <span className="flex-shrink-0 group cursor-pointer">
                                <svg className="group-hover:text-primary transition-colors" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0003 4.16602V15.8327M4.16699 9.99935H15.8337"
                                        stroke="currentColor"
                                        strokeWidth="1.67"
                                        strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                            </span>
                            <span>Add Family Member</span>
                        </button>
                    </div>
                </div>

                <h1 className="text-2xl font-semibold text-gray-800 mb-6">
                    પરિવારના સભ્યની વિગતો
                </h1>

                <div className="space-y-4">
                    {tableData.map((member, index) => (
                        <div
                            key={index}
                            className=" rounded-lg shadow-sm p-4 flex justify-between items-center border"
                        >
                            <div className="flex items-center space-x-3">
                                <p className="text-gray-800 font-medium">{member?.surname + " " + member?.name + " " + member?.fathername || "-"}</p>
                                <span className="text-sm text-[#FC8415] bg-[#FCEADA] px-2 py-1 rounded">
                                    {member.relation?.gujarati_name || member.relation?.english_name || '-'}
                                </span>
                            </div>
                            <div className="flex items-center gap-2">
                                <button className="text-gray-400 hover:text-gray-600" onClick={() => addFamilyMember(member?._id)}>
                                    <svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.30998 29.2793C7.39498 29.2793 6.53998 28.9643 5.92498 28.3793C5.14498 27.6443 4.76998 26.5343 4.90498 25.3343L5.45998 20.4743C5.56498 19.5593 6.11998 18.3443 6.76498 17.6843L19.08 4.64934C22.155 1.39434 25.365 1.30434 28.62 4.37934C31.875 7.45434 31.965 10.6643 28.89 13.9193L16.575 26.9543C15.945 27.6293 14.775 28.2593 13.86 28.4093L9.02998 29.2343C8.77498 29.2493 8.54998 29.2793 8.30998 29.2793ZM23.895 4.36434C22.74 4.36434 21.735 5.08434 20.715 6.16434L8.39998 19.2143C8.09998 19.5293 7.75498 20.2793 7.69498 20.7143L7.13998 25.5743C7.07998 26.0693 7.19998 26.4743 7.46998 26.7293C7.73998 26.9843 8.14498 27.0743 8.63998 26.9993L13.47 26.1743C13.905 26.0993 14.625 25.7093 14.925 25.3943L27.24 12.3593C29.1 10.3793 29.775 8.54934 27.06 5.99934C25.86 4.84434 24.825 4.36434 23.895 4.36434Z" fill="#2D3643" />
                                        <path d="M26.0107 16.4253C25.9807 16.4253 25.9357 16.4253 25.9057 16.4253C21.2257 15.9603 17.4607 12.4053 16.7407 7.75526C16.6507 7.14026 17.0707 6.57026 17.6857 6.46526C18.3007 6.37526 18.8707 6.79526 18.9757 7.41026C19.5457 11.0403 22.4857 13.8303 26.1457 14.1903C26.7607 14.2503 27.2107 14.8053 27.1507 15.4203C27.0757 15.9903 26.5807 16.4253 26.0107 16.4253Z" fill="#2D3643" />
                                        <path d="M31.5 34.125H4.5C3.885 34.125 3.375 33.615 3.375 33C3.375 32.385 3.885 31.875 4.5 31.875H31.5C32.115 31.875 32.625 32.385 32.625 33C32.625 33.615 32.115 34.125 31.5 34.125Z" fill="#2D3643" />
                                    </svg>
                                </button>
                                <button className="text-gray-600 hover:text-red transition-colors" onClick={() => handleDeleteClick(member?._id)}>
                                    <FiTrash2 className="w-5 h-5" />
                                </button>
                            </div>
                        </div>
                    ))}
                    {tableData.length === 0 && (
                        <div className="w-full bg-white">
                            <div className="w-full flex justify-center p-5 ng-star-inserted">
                                <div className="max-w-8xl w-full rounded-2xl p-10 mx-auto bg-gray_1">
                                    <strong className="block text-xl lg:text-2xl 2xl:text-4xl text-center">
                                        No data
                                    </strong>
                                    <span className="block lg:text-18 text-center text-t2">
                                        Please add Family Member
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <DeleteModal
                isOpen={isDeleteModalOpen}
                onClose={() => setIsDeleteModalOpen(false)}
                onConfirm={confirmDelete}
            />
        </>
    );
};

export default EditFamilyList;
